<div class="flex gap-10 items-center mt-1">
  <span>{{ label }}:</span>
  <dx-radio-group
    [dataSource]="dataSource"
    valueExpr="ozelKod"
    displayExpr="aciklama"
    [value]="selectedValue"
    layout="horizontal"
    (onValueChanged)="valueChange.emit($event)"
  >
  </dx-radio-group>
</div>
